module.exports = __webpack_public_path__ + "static/book-cover-0724c9f46c1e7aaea0e9d9d56dabe5b3.png";